import { FC } from 'react'
import { RouterProvider } from 'react-router-dom'
import { routerConfig } from './Router'

import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { Logon } from './page'

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
})

const App: FC = () => {
  const pathname = document.location.pathname

  console.log(pathname)

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      {pathname === '/' ? <Logon /> : <RouterProvider router={routerConfig} />}
    </ThemeProvider>
  )
}

export default App
